(ns nosco.ui.passwords
  (:require
   [hx.react :as hx :refer [defnc]]
   [nosco.i18n.translate :as t]
   [nosco.icons2 :as icons2]
   [nosco.ui.inputs :as inputs]))

(defn humanize-password-strength-error [error]
  (case error
    "length" (t/t "Please choose a password with at least 8 characters")
    "complexity" (t/t "Please choose a stronger password. Try a mix of letters, numbers, and symbols")
    "pwned" (t/t "Please choose a stronger password. This one is too common")
    "not-changed" (t/t "New password is the same as current password")
    nil))

(defnc PasswordWithConfirmationFields
  [{:keys [error
           password-label
           password-value
           on-password-change
           confirm-password-label
           confirm-password-value
           on-confirm-password-change]}]
  (let [password-strength-error (#{"length" "complexity" "pwned" "not-changed"} error)]
    [:<>
     [:div
      [inputs/FormField
       {:label (or password-label (t/t "New password"))
        :required? true
        :error password-strength-error
        :help-text
        (hx/f
         [:span
          [icons2/Icon
           {:icon icons2/Info-small
            :icon-style {:width 12 :height 12}
            :class "mr-spacing-4"}]
          (t/t "Use 8 or more characters with a mix of letters, numbers, and symbols")])}
       [inputs/PasswordInput
        {:value (or password-value  "")
         :revealable true
         :auto-complete "new-password"
         :on-change on-password-change}]]]
     [:div {:class "mt-spacing-24"}
      [inputs/FormField
       {:label (or confirm-password-label (t/t "Confirm new password"))
        :required? true
        :error (cond
                 (= ::not-matching error)
                 {:error-message (t/t "Passwords don't match")}

                 password-strength-error
                 {:error-message (humanize-password-strength-error error)})}
       [inputs/PasswordInput
        {:value (or confirm-password-value "")
         :revealable true
         :auto-complete "new-password"
         :on-change on-confirm-password-change}]]]]))
